import { flex } from '@onbeam/business-styled-system/patterns';
import { Button } from '@onbeam/business-ui';
import { useDisclosure } from '@onbeam/utils';
import { MobileSubNav } from './MobileSubNav';
import { MenuDivider, MenuItem, MenuTitle } from '@/components/shared/Menu';
import { exchangeMenuItems } from '../DesktopNavigation/GetStartedButton/GetStartedButton.utils';
import { css } from '@onbeam/business-styled-system/css';
import { Fragment } from 'react';
import { ArrowDiagonalIcon, ChevronRightIcon } from '@onbeam/icons/business';

export const BuyBeamSubMenu = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <Button variant="primary" size="fullWidth" onClick={onOpen}>
        <div className={flex({ gap: '2', align: 'center' })}>
          Buy Beam <ChevronRightIcon height={16} width={16} />
        </div>
      </Button>
      <MobileSubNav isOpen={isOpen} onClose={onClose}>
        {exchangeMenuItems.map((group, index) => (
          <Fragment key={group.title}>
            <MenuTitle className={css({ px: '0' })}>{group.title}</MenuTitle>
            {group.items.map((item) => (
              <MenuItem
                key={item.href}
                href={item.href}
                isExternal={item.isExternal}
                className={flex({
                  align: 'center',
                  gap: '0.5',
                  px: '0',
                  _hoverFocus: {
                    bg: 'mono.primaryFg',
                    color: 'mono.tertiary',
                  },
                })}
              >
                <span>{item.label}</span>
                {item.isExternal && (
                  <ArrowDiagonalIcon
                    height={16}
                    width={16}
                    className={flex({ flexShrink: 0 })}
                  />
                )}
              </MenuItem>
            ))}
            {index !== group.items.length - 1 && (
              <MenuDivider className={css({ px: '0' })} />
            )}
          </Fragment>
        ))}
      </MobileSubNav>
    </>
  );
};
